'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sectionDeniedUserTypes = exports.permissionsTypesFields = exports.permissionsMap = undefined;

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

var _get3 = require('lodash/get');

var _get4 = _interopRequireDefault(_get3);

exports.getRawPermissionsTypesFields = getRawPermissionsTypesFields;
exports.canCreateProjectByType = canCreateProjectByType;
exports.canUploadMedia = canUploadMedia;
exports.canEditMedia = canEditMedia;
exports.hasContactsAccess = hasContactsAccess;
exports.hasProjectsAccess = hasProjectsAccess;
exports.hasCloudServicesAccess = hasCloudServicesAccess;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var permissionsMap = exports.permissionsMap = {
  createSharespace: 'createSh',
  createProject: 'createProj',
  createNewsletter: 'createNews',
  uploadSharespaceContent: 'uploadShContent',
  uploadSharespaceCover: 'uploadShCover',
  forwarding: 'fwd',
  noPasswordFeature: 'noPassword',
  quickSendAccess: 'quickSend',
  convertQuickSend: 'convertQS',
  uploadOwnProjectMusic: 'uploadPrContent',
  deleteOwnProjectMusic: 'deletePrContent',
  editProjectCover: 'editCover',
  newsWrapAccess: 'newsWrapp'
};

var permissionsTypesFields = exports.permissionsTypesFields = {
  createProject: {
    sharespace: 'createSharespace',
    all: 'createProject',
    audio: 'createProject',
    video: 'createProject',
    newsletter: 'createNewsletter'
  },
  uploadMedia: {
    sharespace: 'uploadSharespaceContent',
    audio: 'uploadOwnProjectMusic',
    video: 'uploadOwnProjectMusic'
  },
  editMedia: {
    sharespace: 'uploadSharespaceContent',
    audio: 'deleteOwnProjectMusic',
    video: 'deleteOwnProjectMusic'
  }
};

var sectionDeniedUserTypes = exports.sectionDeniedUserTypes = {
  contacts: ['listener'],
  projects: ['listener'],
  cloudServices: ['listener']
};

function getRawPermissionsTypesFields() {
  var res = {};
  (0, _entries2.default)(permissionsTypesFields).map(function (_ref) {
    var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
        type = _ref2[0],
        map = _ref2[1];

    res[type] = {};
    (0, _entries2.default)(map).map(function (_ref3) {
      var _ref4 = (0, _slicedToArray3.default)(_ref3, 2),
          subtype = _ref4[0],
          field = _ref4[1];

      res[type][subtype] = permissionsMap[field];
    });
  });

  return res;
}

function hasProjectPermissionsType(_ref5) {
  var permissions = _ref5.permissions,
      projectType = _ref5.projectType,
      permissionsType = _ref5.permissionsType;

  var field = permissionsTypesFields[permissionsType][projectType];
  return !!permissions[field] || false;
}

function canCreateProjectByType(permissions, projectType) {
  return hasProjectPermissionsType({ permissions: permissions, projectType: projectType, permissionsType: 'createProject' });
}

function canUploadMedia(permissions, projectType) {
  return hasProjectPermissionsType({ permissions: permissions, projectType: projectType, permissionsType: 'uploadMedia' });
}

function canEditMedia(permissions, projectType) {
  return hasProjectPermissionsType({ permissions: permissions, projectType: projectType, permissionsType: 'editMedia' });
}

function hasContactsAccess(user) {
  return user && !sectionDeniedUserTypes.contacts.includes(user.type);
}

function hasProjectsAccess(user) {
  return !sectionDeniedUserTypes.projects.includes((0, _get4.default)(user, 'type'));
}

function hasCloudServicesAccess(user) {
  return user && !sectionDeniedUserTypes.cloudServices.includes(user.type);
}


//////////////////
// WEBPACK FOOTER
// ./src/helpers/permissions.js
// module id = 215
// module chunks = 1